import { render, staticRenderFns } from "./AsACoachPendingInspectionRequestsTable.vue?vue&type=template&id=5912fe24&scoped=true"
import script from "./AsACoachPendingInspectionRequestsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AsACoachPendingInspectionRequestsTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AsACoachPendingInspectionRequestsTable.vue?vue&type=style&index=0&id=5912fe24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5912fe24",
  null
  
)

export default component.exports